import { LocalizationService } from 'src/app/shared/services/localization.service';
import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { Select, Store } from '@ngxs/store';
import { Observable, Subscription } from 'rxjs';
import {
  BuildingsActionType,
  ExcelTemplateType,
} from 'src/app/shared/models/enum.model';
import { ExportBuildingsModel } from 'src/app/shared/models/export-buildings.model';
import { ImportBuildingModel } from 'src/app/shared/models/import-buildings.model';
import { MunicipalityModel } from 'src/app/shared/models/municipality.model';
import {
  ExportBuildings,
  ImportBuildings,
} from 'src/app/shared/ngxs/action/building.action';
import { MunicipalityState } from 'src/app/shared/ngxs/state/municipality.state';
import { FilterService } from 'src/app/shared/services/filter.service';
import { LanguageType } from './../../shared/models/enum.model';
import { FilterMunicipalitiesWithoutFiltering } from './../../shared/ngxs/action/municipality.action';

@Component({
  selector: 'app-import-buildings',
  templateUrl: './export-import-buildings.component.html',
  styleUrls: ['./export-import-buildings.component.scss'],
})
export class ExportImportBuildingsComponent implements OnInit, OnDestroy {
  model = new ImportBuildingModel();
  action: BuildingsActionType;

  @Select(MunicipalityState.municipalities)
  municipalities$: Observable<MunicipalityModel[]>;

  municipalities: MunicipalityModel[];
  subscription = new Subscription();

  formGroup: FormGroup;

  languageTypes = LanguageType;
  languageEnumValues = Object.values(LanguageType).filter(
    (type) => isNaN(<any>type) && type !== 'values'
  );

  excelTemplateTypes = ExcelTemplateType;
  enumValues = Object.values(ExcelTemplateType).filter(
    (type) => isNaN(<any>type) && type !== 'values'
  );

  rabaTemplateDescription = '';
  energyTemplateDescription = '';

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private filterService: FilterService,
    private store: Store,
    private formBuilder: FormBuilder,
    private translateService: TranslateService,
    private localizationService: LocalizationService
  ) {
    if (data) {
      this.model = data.model;
      this.action = data.action;
    }

    this.formGroup = this.formBuilder.group({
      municipality: ['', Validators.required],
    });

    this.translateData();
  }

  translateData() {
    this.rabaTemplateDescription =
      this.localizationService.translate('raba-template');
    this.energyTemplateDescription =
      this.localizationService.translate('energy-template');
  }

  getExcelTemplateTypesDesc(type: ExcelTemplateType) {
    switch (type) {
      case ExcelTemplateType.EnergyTemplate:
        return this.energyTemplateDescription;
      case ExcelTemplateType.RabaTemplate:
        return this.rabaTemplateDescription;
      default:
        return '';
    }
  }

  ngOnInit(): void {
    this.store.dispatch(
      new FilterMunicipalitiesWithoutFiltering(
        this.translateService.currentLang
      )
    );

    this.subscribeEvents();
  }

  onProcess() {
    this.model.language =
      this.translateService.currentLang == 'en'
        ? LanguageType.EN
        : LanguageType.MK;

    if (this.action === BuildingsActionType.Import) {
      this.store.dispatch(new ImportBuildings(this.model));
    } else {
      const municipalityName = this.municipalities.find(
        (c) => c.id === this.model.municipalityId
      ).name;
      const exportModel = new ExportBuildingsModel(
        this.model.municipalityId,
        this.model.importType,
        municipalityName,
        this.model.language
      );
      this.store.dispatch(new ExportBuildings(exportModel));
    }
  }

  subscribeEvents() {
    this.subscription.add(
      this.municipalities$.subscribe((x) => {
        this.municipalities = x;
      })
    );

    this.subscription.add(
      this.translateService.onLangChange.subscribe((x) => {
        if (x) {
          this.translateData();
        }
      })
    );
  }

  ngOnDestroy(): void {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }
}
